export const createObjectByKeysExistance = (expectedKeys, object) => (
  expectedKeys.reduce((acc, key) => {
    if (object[key]) {
      acc[key] = object[key]
    }
    return acc
  }, {})
)
